<template>
    <div>
        <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center mb16">
            <div v-if="this.isMobile">
                <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
            </div>
            <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
                {{ this.$store.state.modal.content.title }}
            </div>
            <div v-if="!this.isMobile">
                <Icon name="close" class="c24 pointer" @click="this.close()"/>
            </div>
        </div>

        <div class="bg-white rounded12" :class="{ 'p0': isMobile, 'p24': !isMobile }">
            <component 
                :is="currentFilterComponent" 
                :initialFilters="this.filterData"
                @filterUpdate="this.onFilterUpdate"
                @updateParentState="this.onUpdateParentState"
                ref="filterComponent"
            />
            
            <div class="d-flex mt24" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
                <Button type="btn-warning" class="equal-width h48 mr16" @click="this.save()">{{ $t('components.service.modal.AssetsFilter.17') }}</Button>
                <Button type="btn-outline-grey" class="equal-width h48 primary-grey" @click="this.clearAll()">{{ $t('components.service.modal.AssetsFilter.18') }}</Button>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon'
import Button from '@/components/service/Button'
import AdsFilters from './AdsFilters.vue'
import SwapsFilters from './SwapsFilters.vue'
import OffersFilters from './OffersFilters.vue'

export default {
    name: 'P2PFilters',
    components: {
        Icon,
        Button,
        AdsFilters,
        SwapsFilters,
        OffersFilters
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768
        },
        currentFilterComponent() {
            const componentMap = {
                'ads': 'AdsFilters',
                'swaps': 'SwapsFilters',
                'offers': 'OffersFilters'
            }
            // Получаем page из пропа или из store
            const page = this.$store.state.modal.content?.page || 'ads';
            return componentMap[page] || 'AdsFilters'
        }
    },
    data() {
        return {
            filterData: {}
        }
    },
    created() {
        // Получаем начальные данные фильтров из store или props
        this.filterData = this.$store.state.modal.content?.filters || {};
    },
    methods: {
        onFilterUpdate(filters) {
            this.filterData = { ...filters };
        },
        onUpdateParentState(state) {
            // Обновляем filterData при изменении отдельных полей
            this.filterData[state.id] = state.value;
            
            // Также обновляем данные в дочернем компоненте
            if (this.$refs.filterComponent && this.$refs.filterComponent.fields) {
                this.$refs.filterComponent.fields[state.id] = state.value;
            }
        },
        save() {
            // Получаем актуальные данные из дочернего компонента
            if (this.$refs.filterComponent && this.$refs.filterComponent.fields) {
                this.filterData = { ...this.$refs.filterComponent.fields };
                console.log('P2PFilters save filterData:', this.filterData);
            }
            
            // Применяем фильтры в дочернем компоненте
            if (this.$refs.filterComponent && this.$refs.filterComponent.applyFilters) {
                this.$refs.filterComponent.applyFilters();
            }
            
            // Передаем данные фильтров в callback
            if (this.$store.state.modal.content.callback) {
                this.$store.state.modal.content.callback(this.filterData)
            }
            this.close()
        },
        clearAll() {
            // Очищаем фильтры в дочернем компоненте
            if (this.$refs.filterComponent && this.$refs.filterComponent.clearFilters) {
                this.$refs.filterComponent.clearFilters();
            }
            // Обновляем локальные данные фильтров
            this.filterData = {};
        }
    }
}
</script>
